import parseISO from 'date-fns/parseISO'
import { FilterUtils } from '@ocean/utils'
import { Resource } from 'components/common/BigCalendar/types'
import { namespace } from 'modules/virtualClassrooms/common/localization'
import { VirtualEventStatus } from 'modules/virtualClassrooms/common/types/manager'
import {
  VirtualEventsListSchedule,
  VirtualEventScheduleEvent,
  VirtualEventScheduleStatus,
  RoomSettings,
} from 'modules/virtualClassrooms/manager/Schedules/types'

class PlannerUtils {
  I18_PLANNER_PATH = `${namespace}:manager.schedules.planner`

  resources: Resource[] = []

  setResources(settings: RoomSettings[]) {
    this.resources = settings.map(({ name, roomSettingId }) => ({
      resourceId: roomSettingId,
      resourceTitle: name,
    }))
  }

  getResourceName(id: Guid) {
    const resource = this.resources.find(({ resourceId }) => resourceId === id)
    return resource?.resourceTitle || ''
  }

  DEFAULT_VIRTUAL_EVENTS_LIST_SCHEDULE: VirtualEventsListSchedule = {
    createdBy: '',
    createdDate: FilterUtils.formatDate(new Date()),
    startDate: FilterUtils.formatDate(new Date()),
    endDate: FilterUtils.formatDate(new Date()),
    event: {
      id: '',
      categoryId: '',
      title: '',
      description: '',
      createdDate: FilterUtils.formatDate(new Date()),
      updatedDate: FilterUtils.formatDate(new Date()),
      createdBy: '',
      updatedBy: '',
      maximumParticipants: 0,
      allowParticipantsToJoinWaitList: false,
      allowParticipantsToSelfBook: false,
      eventStatus: VirtualEventStatus.Draft,
    },
    id: '',
    publishedDate: FilterUtils.formatDate(new Date()),
    status: VirtualEventScheduleStatus.Open,
    timeZone: 'Europe/London',
    updatedBy: '',
    dateOfChange: FilterUtils.formatDate(new Date()),
    roomId: 0,
    roomSettingId: '',
  }

  mapScheduleToPlanner(
    scheduleList: VirtualEventsListSchedule[],
    scheduleId?: Guid
  ): VirtualEventScheduleEvent[] {
    const normalizedSessions = scheduleList.reduce((result, schedule) => {
      const { id, startDate, endDate, event, roomSettingId } = schedule

      if (new Date(startDate) >= new Date(endDate)) return result

      // It is possible to have schedules with expired (not existing) roomSettingId
      const isRoomSettingIdExists = this.resources.some(
        ({ resourceId }) => resourceId === roomSettingId
      )
      // Put schedules with unknown roomSettingId into first available room
      const resourceId = isRoomSettingIdExists ? roomSettingId : this.resources[0].resourceId

      // During creating schedule has same 'id' and 'event.id'
      const isCreatedSchedule = !!id && !!event.id && id === event.id
      // Is schedule belongs to route scheduleId
      const isBelongsSchedule = scheduleId === id
      const isCurrentBooking = isBelongsSchedule || isCreatedSchedule

      const plannerSession: VirtualEventScheduleEvent = {
        id,
        eventId: event.id,
        title: event.title,
        start: parseISO(startDate),
        end: parseISO(endDate),
        // String because validation on falsy into 'react-big-calendar'
        resourceId,
        currentBooking: isCurrentBooking,
      }

      return [...result, plannerSession]
    }, [] as VirtualEventScheduleEvent[])

    return normalizedSessions
  }
}

export default new PlannerUtils()
